/**
 * Sticky "Shop Now" bar
 *
 * Shows a fixed bar at the bottom of the viewport when the primary
 * Add-to-Cart button scrolls out of view. The "Shop Now" CTA smooth-scrolls
 * the user back to the product info / purchase section.
 */

(function initStickyShopNowBar() {
  'use strict';

  const VISIBLE_CLASS = 'sticky-shop-now-bar--visible';

  /**
   * Repositions the Freshworks chat widget so it sits above the sticky bar.
   * @param {boolean} isBarVisible
   * @param {HTMLElement} bar
   */
  const repositionFreshworksWidget = (isBarVisible, bar) => {
    const freshworksIframe = document.querySelector('#freshworks-container iframe');
    if (!freshworksIframe) {
      return;
    }

    if (isBarVisible) {
      const barHeight = bar.getBoundingClientRect().height;
      freshworksIframe.style.setProperty('bottom', `${barHeight}px`, 'important');
    } else {
      freshworksIframe.style.removeProperty('bottom');
    }
  };

  /**
   * @param {HTMLElement} bar
   * @param {HTMLElement} atcButton
   * @param {HTMLElement} scrollTarget
   */
  const setup = (bar, atcButton, scrollTarget) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scrolledAboveViewport = entry.boundingClientRect.bottom < 0;

          if (scrolledAboveViewport) {
            bar.classList.add(VISIBLE_CLASS);
            repositionFreshworksWidget(true, bar);
          } else {
            bar.classList.remove(VISIBLE_CLASS);
            repositionFreshworksWidget(false, bar);
          }
        });
      },
      { threshold: 0 },
    );

    observer.observe(atcButton);

    bar.querySelector('[data-sticky-bar-cta]')?.addEventListener('click', (event) => {
      event.preventDefault();
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  const init = () => {
    const bar = document.querySelector('[data-sticky-shop-now-bar]');
    if (!bar) {
      return;
    }

    const sectionId = bar.dataset.sectionId;
    if (!sectionId) {
      return;
    }

    const atcButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const scrollTarget = document.querySelector(`#ProductInfo-${sectionId}`);

    if (!atcButton || !scrollTarget) {
      return;
    }

    setup(bar, atcButton, scrollTarget);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
